(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["block-contact-form"] && !window.DesignMode) return;
  try {
    
  document.getElementById('ContactFormBlock').addEventListener('submit', function (event) {
    event.preventDefault() // Prevent default form submission
    const formData = new FormData(this)
    console.log('Form data:', Object.fromEntries(formData.entries())) // Log form data
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-faq"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('#accordion .accordion-item')

    items.forEach((item) => {
      const header = item.querySelector('.accordion-header')
      const body = item.querySelector('.accordion-body')
      const icon = item.querySelector('svg')

      header.addEventListener('click', () => {
        const isOpen = body.style.maxHeight && body.style.maxHeight !== '0px'

        // Close all
        items.forEach((el) => {
          el.querySelector('.accordion-body').style.maxHeight = '0px'
          el.querySelector('svg').classList.remove('tw-rotate-180', 'tw-text-primary')
          el.querySelector('.accordion-header').classList.remove('[&>span]:tw-text-primary')
        })

        // Toggle current
        if (!isOpen) {
          body.style.maxHeight = body.scrollHeight + 'px'
          header.classList.add('[&>span]:tw-text-primary')
          icon.classList.add('tw-rotate-180', 'tw-text-primary')
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-logo-slider"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const track = document.querySelector('.js-logo-slider-track')
    if (!track) return

    const slides = Array.from(track.children)
    slides.forEach((slide) => {
      const clone = slide.cloneNode(true)
      clone.classList.add('logo-slider__slide--clone')
      track.appendChild(clone)
    })

    let scrollSpeed = 100 // pixels per second
    let currentScroll = 0
    let lastTimestamp = null
    let isPaused = false

    // Wait for layout to settle, then capture correct width
    requestAnimationFrame(() => {
      const halfScrollWidth = track.scrollWidth / 2

      function animate(timestamp) {
        if (lastTimestamp === null) lastTimestamp = timestamp

        const delta = (timestamp - lastTimestamp) / 1000 // seconds
        lastTimestamp = timestamp

        if (!isPaused) {
          currentScroll += scrollSpeed * delta

          if (currentScroll >= halfScrollWidth) {
            currentScroll = 0
          }

          track.style.transform = `translateX(-${currentScroll}px)`
        }

        requestAnimationFrame(animate)
      }

      requestAnimationFrame(animate)
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-promotional-banner"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const banner = document.querySelector('.block-promo-banner')
    const track = document.querySelector('.js-slider-track')
    if (!track) return

    const slides = Array.from(track.children)
    slides.forEach((slide) => {
      const clone = slide.cloneNode(true)
      clone.classList.add('slider__slide--clone')
      track.appendChild(clone)
    })

    let scrollSpeed = 100 // pixels per second
    let currentScroll = 0
    let lastTimestamp = null
    let isPaused = false

    // Wait for layout to settle, then capture correct width
    requestAnimationFrame(() => {
      const halfScrollWidth = track.scrollWidth / 2

      function animate(timestamp) {
        if (lastTimestamp === null) lastTimestamp = timestamp

        const delta = (timestamp - lastTimestamp) / 1000 // seconds
        lastTimestamp = timestamp

        if (!isPaused) {
          currentScroll += scrollSpeed * delta

          if (currentScroll >= halfScrollWidth) {
            currentScroll = 0
          }

          track.style.transform = `translateX(-${currentScroll}px)`
        }

        requestAnimationFrame(animate)
      }

      // Desktop-only hover pause
      banner.addEventListener('mouseenter', () => {
        isPaused = true
      })
      banner.addEventListener('mouseleave', () => {
        isPaused = false
      })

      // Mobile interaction
      banner.addEventListener('pointerdown', () => {
        isPaused = true
      })

      banner.addEventListener('pointerup', () => {
        isPaused = false
      })

      requestAnimationFrame(animate)
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
